module.exports = __webpack_public_path__ + "static/media/windows2.c3bf619a.png";